import { render } from "./SettingsCategory.vue?vue&type=template&id=07b11e32"
import script from "./SettingsCategory.vue?vue&type=script&lang=js"
export * from "./SettingsCategory.vue?vue&type=script&lang=js"

import "./SettingsCategory.vue?vue&type=style&index=0&id=07b11e32&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__